<div [ngClass]="!(profileState | async).loader['audit']['mediaAnalyze'] ? 'background-loader' : ''">
  <div class="spinner" *ngIf="!(profileState | async).loader['audit']['mediaAnalyze']"></div>
    <h3 class="card-header">
      {{title()}}
<!--      <a data-tooltip="Tooltip text">-->
<!--        <img class="icon-info" src="./assets/images/icons/info.png" />-->
<!--      </a>-->
    </h3>
    <div
      class="mt-3 text-center box-md"
      *ngIf="charts !== undefined"
    >
      <div [chart]="charts[0]"></div>
  </div>
</div>
